export const SHOPIFY = 'SHOPIFY';
export const MAGENTO = 'MAGENTO';
export const WOOCOMMERCE = 'WOOCOMMERCE';
export const BIGCOMMERCE = 'BIGCOMMERCE';
export const WIX = 'WIX';
export const WISH = 'WISH';
export const STORE_TYPES = [SHOPIFY, /*MAGENTO,*/ WOOCOMMERCE, BIGCOMMERCE/*, WIX, WISH*/];
